














import {
  defineComponent,
  PropType,
  ref,
  computed,
} from "@nuxtjs/composition-api";
import type { WMProductAttributeGroup } from "@wemade-vsf/catalog/lib/runtime/product/types";
import { SfButton } from "@storefront-ui/vue";

import ProductAttributeGroupValue from "./ProductAttributeGroupValue.vue";

export default defineComponent({
  name: "AttributeGroup",
  props: {
    attributeGroup: {
      type: [Object, null] as PropType<WMProductAttributeGroup | null>,
      default: null,
    },
  },
  components: {
    SfButton,
    ProductAttributeGroupValue,
  },
  setup(props) {
    const isOpen = ref(true);
    const groupLabel = computed(() => props?.attributeGroup?.label || "");
    const attributes = computed(() => props?.attributeGroup?.attributes || []);
    return {
      attributes,
      groupLabel,
      isOpen,
    };
  },
});
